import { useContext } from 'react';
import { CropAdjustmentContext } from './Contexts';
import { MouseAvailabilityContext } from './MouseFocusProvider';
import { DragGeometryContext } from './MouseDragProvider';

export default function ResizeElementWrapper({children}){

  //const { info } = useContext(DragGeometryContext);

  const cropResizeInfo = useContext(CropAdjustmentContext);


  return !cropResizeInfo && children;

}
